import { useRoute } from 'vue-router';

import type { NavMenuItem } from '@/router/navigation';

export function useNavigation() {
  const route = useRoute();

  const isActive = (routeToCheck: string) => {
    return route.path.startsWith(routeToCheck);
  };

  const removeLastMenuItem = (menu: NavMenuItem[]): NavMenuItem[] => {
    return menu.slice(0, -1);
  };

  const getFirstItemOfLastMenuSection = (menu: NavMenuItem[]): NavMenuItem | undefined => {
    const lastMenu = menu[menu.length - 1];
    if (!lastMenu || !lastMenu.children || lastMenu.children.length === 0) {
      return undefined;
    }
    return lastMenu.children[0];
  };

  const getLastMenuSection = (menu: NavMenuItem[]): NavMenuItem | undefined => {
    const lastMenu = menu[menu.length - 1];
    return {
      route: lastMenu?.route,
      name: lastMenu?.name ?? '',
      title: lastMenu?.title ?? '',
      icon: lastMenu?.icon,
    };
  };

  return { isActive, removeLastMenuItem, getFirstItemOfLastMenuSection, getLastMenuSection };
}
